
export const transformStateToAgiloft = (companyInfo, primaryContract, secondaryContract, services, promoCode, recaptchaToken) => {
    return {
        companyName: companyInfo.name,
        country: companyInfo.country,
        registrationNumber: companyInfo.registrationNumber,
        safeNumber: companyInfo.safeNumber,
        streetAddress1: companyInfo.streetAddress1,
        streetAddress2: companyInfo.streetAddress2,
        city: companyInfo.city,
        zip: companyInfo.zip,
        participantCategory: 'Suppliers to NCS',
        services: services || ['Magnet JQS Basic'],
        primaryContract: primaryContract,
        secondaryContract: secondaryContract,
        promotionCode: promoCode.code,
        recaptchaToken: recaptchaToken
    }
}
